<div class="container">
  <div>
    @if (shipment) {
      <h1 class="cx-page-title">
        {{ 'checkoutOrderConfirmation.confirmationOfOrder' | cxTranslate }}
        {{ shipment.code }}
      </h1>
    }

    @if (!isCreditNoteRequest && shipment) {
      <div class="cx-order-confirmation-message">
        <h2>{{ 'checkoutOrderConfirmation.thankYou' | cxTranslate }}</h2>
      </div>
    }
    @if (isCreditNoteRequest) {
      <div class="cx-order-confirmation-message">
        <h2>{{ 'dispenserAgreement.thankYou' | cxTranslate }}</h2>
      </div>
    }
  </div>

  @if (!isCreditNoteRequest && shipment) {
    <div class="cx-order-summary">
      <div class="container">
        <div class="cx-summary-card">
          <cx-card [content]="getRequestedDeliveryDate(shipment.shipmentDate) | async"></cx-card>
        </div>
        <ng-container>
          <div class="cx-summary-card">
            <cx-card [content]="getPurchaseOrderNumber(shipment.poNumber) | async"></cx-card>
          </div>
        </ng-container>
        @if (getAddressCardContent(shipment.address) | async; as address) {
          <div class="cx-summary-card">
            <cx-card [content]="address"></cx-card>
          </div>
        }
      </div>
    </div>
  }

  @if (shipment) {
    <div class="cx-order-items container mt-4 mb-5">
      @if (!isCreditNoteRequest) {
        <h3 class="cx-order-items-header">
          {{ 'checkoutOrderConfirmation.orderItems' | cxTranslate }}
        </h3>
      }
      @if (isCreditNoteRequest) {
        <h3 class="cx-order-items-header">
          {{ 'dispenserAgreement.creditRequestItems' | cxTranslate }}
        </h3>
      }
      <app-dispenser-order-items-list [entries]="shipment.entries" [readonly]="true"></app-dispenser-order-items-list>
    </div>
  }

  <mat-card class="dispenser-agreement-order__body">
    <h3 class="dispenser-agreement-order__body__title">
      {{ 'dispenserAgreement.submitted' | cxTranslate }}
    </h3>
    <div>
      @if (isCreditNoteRequest) {
        <p>Your credit note request for {{ quantityOrdered }} dispensers has been submitted.</p>
      } @else {
        <p>
          {{ quantityOrdered }} dispensers are being sent to {{ agreement.endCustomer?.name }} at
          {{ finalFormattedAddress }}.
        </p>
      }

      @if (user && !isCreditNoteRequest) {
        <p>We have sent a confirmation email to {{ user.uid }}</p>
      }
    </div>
    <div class="action-button">
      <button class="btn btn-primary" (click)="eventBack.emit()">{{ 'shared.backTo.placeOrder' | cxTranslate }}</button>
    </div>
  </mat-card>
</div>
